import { REPORT_TYPE } from 'features/reports/types';
import { createElement, ReactNode } from 'react';
import { lazyImport } from 'routes/helpers';
import { getPath } from 'routes/router-paths';

export type TBreadcrumb = {
  title: string;
  path?: string;
};

export type TRoute = {
  path: string;
  element: ReactNode;
  permissionKeys?: string[];
  pageHeader?: string;
  breadcrumbs?: TBreadcrumb[];
};

export const publicRoutes: TRoute[] = [
  {
    path: getPath('loginPage'),
    element: createElement(
      lazyImport(() => import('modules/Authentication/LoginPage'))
    ),
  },
  {
    path: getPath('keycloakAuthenticationPage'),
    element: createElement(
      lazyImport(
        () => import('modules/Authentication/KeycloakAuthenticationPage')
      )
    ),
  },
];

export const privateRoutes: TRoute[] = [
  {
    path: getPath('portalPage'),
    element: createElement(
      lazyImport(() => import('modules/Miscellaneous/PortalPage'))
    ),
  },
  {
    path: getPath('reportPage', ':reportType' as REPORT_TYPE),
    element: createElement(
      lazyImport(() => import('modules/Reports/ReportPage'))
    ),
  },
];
